import { createAction } from 'redux-actions';
import { instance } from "../../../config/interceptor";

export const cleanupAction = createAction('CLEANUP_ADD_SERVICE');

export const cleanup = ()  => async (dispatch) => {
  dispatch(cleanupAction());
}

export const addServiceRequest = createAction('ADD_SERVICE_POST_REQUEST');
export const addServiceSuccess = createAction('ADD_SERVICE_POST_SUCCESS');
export const addServiceError = createAction('ADD_SERVICE_POST_ERROR');

export const addService = (request) => async (dispatch) => {
  try {
    dispatch(addServiceRequest());
    const resp = await instance.post(`/v1/Service/Post`, request);

    dispatch(addServiceSuccess(resp.data));
  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(addServiceError(e.response.data.description));
    else
      dispatch(addServiceError(e.message));
  }
};
